import { render, staticRenderFns } from "./LeaderUser.vue?vue&type=template&id=17839d6b&"
import script from "./LeaderUser.vue?vue&type=script&lang=js&"
export * from "./LeaderUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports